import { useQuery } from '@tanstack/react-query'
import { syncService } from '../../services/sync/syncService'

export const useSyncStatus = () => {
  return useQuery({
    queryKey: ['syncStatus'],
    queryFn: syncService.getBookersSyncStatus,
    refetchInterval: 30000, // Refetch every 30 seconds
    staleTime: 10000, // Consider data stale after 10 seconds
  })
}
